module.exports = __webpack_public_path__ + "static/media/private-thumbnail.c7620978.png";